// Price rules follow MT Admin (countryFeatures.ts / macMenuExamples.ts / MacMenuExamplesDialog.tsx).

// Legacy's `currencyCharComponent`: Canada (and Australia) show a bare '$', exactly like the US.
const CURRENCY_CHARS: Record<string, string> = {
    USA: '$',
    CAN: '$',
    UK: '£',
    BGD: '৳',
    UAE: 'د.إ',
    AUS: '$',
    HKG: 'HK$',
    IND: '₹',
    IRL: '€',
    MYS: 'RM',
    PAK: 'Rs',
    PHL: '₱',
    THA: '฿',
    SGP: 'S$',
    FRA: '€',
    GER: '€',
};

// USA shows a bare "Price"; Canada names its dollars, since '$' alone wouldn't say which.
const PRICE_LABELS: Record<string, string> = {
    USA: 'Price',
    CAN: 'Price (CAD)',
};

export function getCurrencyChar(countryCode: string): string {
    return CURRENCY_CHARS[countryCode.toUpperCase()] ?? '$';
}

export function getPriceLabel(countryCode: string): string {
    return PRICE_LABELS[countryCode.toUpperCase()] ?? `Price (${getCurrencyChar(countryCode)})`;
}

// The server formats the number; only the currency symbol is added. '' and '-' mean "no price" and stay as is.
export function formatMenuExamplePrice(price: string, countryCode: string): string {
    return price === '' || price === '-' ? price : `${getCurrencyChar(countryCode)}${price}`;
}
